import gql from "graphql-tag";

const notifyUserData = gql`
    mutation NotifyUserData($action: UserDataAction!, $mail: String!) {
        NotifyUserData(action: $action, mail: $mail)
    }
`;

export default notifyUserData;
